import Vue from 'vue'
import VueRouter from 'vue-router'
import Layout from '@/components/layout.vue'

Vue.use(VueRouter)
// 解决触发同一路由报错问题
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
/**
 * hiddenMenu: ------------------默认false  设为true是不显示在菜单项里
 * id:         ------------------后台对应  不要改
 * name: ------------------------一级菜单不要写，------ 面包屑会用到
 * meta: {
 *  title: 'title'  the name show in sidebar and breadcrumb (recommend set)
 *  icon: '' 目前一级菜单设置  二级不用
 * }
 */

// 固定路由  只留了 登录  注册  找回密码
export const constantRoutes = [
  {
    path: '/login',
    name: 'Login',
    hiddenMenu: true,
    meta: {
      title: '登录'
    },
    component: () => import('@/views/Login.vue')
  },
  {
    path: '/stuHome',
    name: 'stuHome',
    redirect: '/stuHome/home',
    component: () => import('@/views/student/stuHome.vue'),
    children: [
      {
        path: '/stuHome/register',
        name: 'register',
        meta: {
          isStudent: true
        },
        component: () => import('@/views/student/register/register.vue'),
      },
      {
        path: '/stuHome/resetPassword',
        name: 'resetPassword',
        meta: {
          isStudent: true
        },
        component: () => import('@/views/student/resetPassword/resetPassword.vue'),
      },
    ]
  },
  {
    path: '/test',
    name: 'test',
    hiddenMenu: true,
    component: () => import('@/views/test.vue')
  }
]

// 管理端路由表  学生端路由在 modules/student.js里配
export const asyncRoutes = [
  {
    path: '/',
    id: '1',
    name: 'Home',
    component: Layout,
    redirect: '/index',
    meta: {
      title: '首页',
      icon: 'home-icon.png',
    },
    noShowingChildren: true,
    children: [
      {
        path: 'index',
        id: '1',
        name: 'index',
        component: () => import('@/views/index'),
        meta: {
          title: '首页'
        }
      }
    ]
  },
  {
    path: '/',
    id: '2',
    component: Layout,
    redirect: '/school',
    meta: {
      title: '基础设置',
      icon: 'paper-icon.png',
    },
    children: [
      {
        path: 'school',
        name: 'school',
        id: '2-1',
        component: () => import('@/views/baseSet/school/school.vue'),
        meta: {
          title: '学校管理'
        }
      },
      {
        path: 'station',
        name: 'station',
        id: '2-2',
        component: () => import('@/views/baseSet/station/station.vue'),
        meta: {
          title: '函授站管理'
        }
      },
      {
        path: 'level',
        name: 'level',
        id: '2-9',
        component: () => import('@/views/baseSet/level/level.vue'),
        meta: {
          title: '层次管理'
        }
      },
      {
        path: 'major',
        name: 'major',
        id: '2-3',
        component: () => import('@/views/baseSet/major/major.vue'),
        meta: {
          title: '专业管理'
        },
      },
      {
        path: 'course',
        name: 'course',
        id: '2-4',
        component: () => import('@/views/baseSet/course/course.vue'),
        meta: {
          title: '课程管理'
        }
      },
      {
        path: 'ots',
        name: 'ots',
        id: '2-5',
        component: () => import('@/views/ots.vue'),
        meta: {
          title: '试题试卷管理'
        }
      },
      {
        path: 'examSite',
        name: 'examSite',
        id: '2-6',
        component: () => import('@/views/baseSet/examSite/examSite.vue'),
        meta: {
          title: '考点管理'
        },
        children: [
          {
            path: 'add',
            name: 'addSite',
            id: '2-6',
            meta: {
              title: '新增考点'
            },
            component: () => import('@/views/baseSet/examSite/addSite.vue')
          },
          {
            path: 'edit',
            name: 'editSite',
            id: '2-6',
            meta: {
              title: '编辑考点'
            },
            component: () => import('@/views/baseSet/examSite/addSite.vue')
          }
        ]
      },
      {
        path: 'classroom',
        name: 'classroom',
        id: '2-7',
        component: () => import('@/views/baseSet/classroom/classroom.vue'),
        meta: {
          title: '教室管理'
        }
      },
      {
        path: 'majorCourse',
        name: 'majorCourse',
        id: '2-8',
        component: () => import('@/views/baseSet/majorCourse/majorCourse.vue'),
        meta: {
          title: '专业课程设置'
        },
        children: [
          {
            path: 'addMajorCourse',
            name: 'addMajorCourse',
            id: '2-8',
            meta: {
              title: '添加专业课程'
            },
            component: () => import('@/views/baseSet/majorCourse/majorCourseAdd.vue'),
          },
        ]
      },
    ]
  },
  {
    path: '/',
    id: '3',
    component: Layout,
    redirect: '/applyManage',
    meta: {
      title: '报缴管理',
      icon: 'agency-icon.png',
    },
    children: [
      {
        path: 'studentManageMent',
        name: 'studentManageMent',
        id: '3-8',
        component: () => import('@/views/applySet/studentManageMent.vue'),
        meta: {
          title: '学生管理'
        },
      },
      {
        path: 'applyManage',
        name: 'applyManage',
        id: '3-1',
        component: () => import('@/views/applySet/applyManage.vue'),
        meta: {
          title: '报名管理'
        },
        children: [
          {
            path: 'applyManageAdd',
            name: 'applyManageAdd',
            id: '3-1',
            component: () => import('@/views/applySet/applyManageAdd.vue'),
            meta: {
              title: '新增报缴信息'
            },

          },
        ]
      },
      {
        path: 'applyFirst',
        name: 'applyFirst',
        id: '3-2',
        component: () => import('@/views/applySet/applyFirst.vue'),
        meta: {
          title: '报名初审'
        },
        children: [
          {
            path: 'applyAuditDetail',
            name: 'applyFirstDetail',
            id: '3-2',
            component: () => import('@/views/applySet/applyAuditDetail.vue'),
            meta: {
              title: '审核详情'
            },
          },
        ]
      },
      {
        path: 'applyAudit',
        name: 'applyAudit',
        id: '3-7',
        component: () => import('@/views/applySet/applyAudit.vue'),
        meta: {
          title: '报名终审'
        },
        children: [
          {
            path: 'applyAuditDetail',
            name: 'applyAuditDetail',
            id: '3-7',
            component: () => import('@/views/applySet/applyAuditDetail.vue'),
            meta: {
              title: '审核详情'
            },
          },
        ]
      },
      {
        path: 'payManagement',
        name: 'payManagement',
        id: '3-3',
        component: () => import('@/views/applySet/payManagement.vue'),
        meta: {
          title: '缴费管理'
        }
      },
      {
        path: 'payOrders',
        name: 'payOrders',
        id: '3-4',
        component: () => import('@/views/applySet/payOrders.vue'),
        meta: {
          title: '缴费订单'
        }
      },
      {
        path: 'messagePush',
        name: 'messagePush',
        id: '3-5',
        component: () => import('@/views/applySet/messagePush.vue'),
        meta: {
          title: '短信督导',
        }
      },
      {
        path: 'messageDetailed',
        name: 'messageDetailed',
        id: '3-6',
        component: () => import('@/views/applySet/messageDetailed.vue'),
        meta: {
          title: '短信明细',
        }
      }
    ]
  },
  {
    path: '/',
    component: Layout,
    id: '4',
    redirect: '/examBatch',
    meta: {
      title: '考试管理',
      icon: 'exam-icon.png',
    },
    children: [
      {
        path: 'examBatch',
        name: 'examBatch',
        id: '4-1',
        component: () => import('@/views/examSet/examBatch/examBatch.vue'),
        meta: {
          title: '考试批次管理'
        },
        children: [
          {
            path: 'add',
            name: 'addBatch',
            id: '4-1',
            meta: {
              title: '新增考试批次'
            },
            component: () => import('@/views/examSet/examBatch/addBatch.vue')
          },
          {
            path: 'edit',
            name: 'editBatch',
            id: '4-1',
            meta: {
              title: '编辑考试批次'
            },
            component: () => import('@/views/examSet/examBatch/addBatch.vue')
          },
          {
            path: 'check',
            name: 'checkBatch',
            id: '4-1',
            meta: {
              title: '查看考试批次'
            },
            component: () => import('@/views/examSet/examBatch/checkBatch.vue')
          },
        ]
      },
      {
        path: 'mockExam',
        name: 'mockExam',
        id: '4-2',
        component: () => import('@/views/examSet/mockExam/mockExam.vue'),
        meta: {
          title: '模考设置'
        },
      },
      {
        path: 'section',
        name: 'section',
        id: '4-3',
        component: () => import('@/views/examSet/section/section.vue'),
        meta: {
          title: '场次设置'
        },
        children: [
          {
            path: 'add',
            name: 'addSection',
            id: '4-3',
            meta: {
              title: '新增场次'
            },
            component: () => import('@/views/examSet/section/addSection.vue')
          },
          {
            path: 'edit',
            name: 'editSection',
            id: '4-3',
            meta: {
              title: '编辑场次'
            },
            component: () => import('@/views/examSet/section/addSection.vue')
          },
          {
            path: 'check',
            name: 'checkSection',
            id: '4-3',
            meta: {
              title: '查看场次'
            },
            component: () => import('@/views/examSet/section/checkSection.vue')
          }
        ]
      },
      {
        path: 'classSet',
        name: 'classSet',
        id: '4-4',
        component: () => import('@/views/examSet/classSet/classSet.vue'),
        meta: {
          title: '考场安排'
        },
        children: [
          {
            path: 'history',
            name: 'historyClass',
            id: '4-4',
            meta: {
              title: '历史查询'
            },
            component: () => import('@/views/examSet/classSet/history.vue')
          },
          {
            path: 'student',
            name: 'student',
            id: '4-4',
            meta: {
              title: '考生安排'
            },
            component: () => import('@/views/examSet/classSet/student.vue')
          },
          {
            path: 'signTable',
            name: 'signTable',
            id: '4-4',
            meta: {
              title: '签到表下载'
            },
            component: () => import('@/views/examSet/classSet/signTable.vue')
          },
        ]
      },
      {
        path: 'score',
        name: 'score',
        id: '4-5',
        component: () => import('@/views/examSet/score/score.vue'),
        meta: {
          title: '成绩管理'
        },
        children: [
          
          {
            path: 'currentScore',
            name: 'currentScore',
            id: '4-5',
            meta: {
              title: '考生成绩'
            },
            component: () => import('@/views/examSet/score/currentScore.vue')
          }
        ]
      },
      {
        
        path: 'history',
        name: 'historyScore',
        id: '4-6',
        meta: {
          title: '成绩查询'
        },
        component: () => import('@/views/examSet/score/historyScore.vue')
        
      },
      {
        path: 'varAudit',
        name: 'varAudit',
        id: '4-8',
        meta: {
          title: "机考人脸验证审核"
        },
        component: () => import('@/views/examSet/varAudit/varAudit.vue')
      }
    ]
  },

  {
    path: '/',
    component: Layout,
    id: '8',
    redirect: '/markPaper',
    meta: {
      title: '阅卷管理',
      icon: 'reviewTeacher-icon.png',
    },
    children: [
      {
        path: 'reviewTeacher',
        name: 'reviewTeacher',
        id: '8-1',
        component: () => import('@/views/markPaper/reviewTeacher/reviewTeacher.vue'),
        meta: {
          title: '评阅教师管理'
        }
      },
      {
        path: 'autoAssign',
        name: 'autoAssign',
        id: '8-2',
        component: () => import('@/views/markPaper/autoAssign/autoAssign.vue'),
        meta: {
          title: '评阅自动分配'
        }
      },
      {
        path: 'manuAssign',
        name: 'manuAssign',
        id: '8-3',
        component: () => import('@/views/markPaper/manuAssign/manuAssign.vue'),
        meta: {
          title: '评阅手动分配'
        }
      },
      {
        path: 'situationStatistics',
        name: 'situationStatistics',
        id: '8-4',
        component: () => import('@/views/markPaper/situationStatistics/situationStatistics.vue'),
        meta: {
          title: '评阅情况统计'
        }
      },
      {
        path: 'review',
        name: 'review',
        id: '8-5',
        component: () => import('@/views/markPaper/review/review.vue'),
        meta: {
          title: '教师评阅'
        },
        children: [
          {
            path: "reviewDetail",
            name: "reviewDetail",
            id: "8-5",
            component: () => import('@/views/markPaper/review/reviewDetail.vue'),
            meta: {
              title: "已评阅列表"
            }
          }
        ]
      }
    ]
  },

  {
    path: '/',
    component: Layout,
    id: "5",
    redirect: '/notice',
    meta: {
      title: '公告管理',
      icon: 'notice.png',
    },
    children: [
      {
        path: 'notice',
        name: 'notice',
        id: "5-1",
        component: () => import('@/views/notice/noticeManagement.vue'),
        meta: {
          title: '公告管理'
        },
        children: [
          {
            path: 'add',
            name: 'addNotice',
            id: "5-1",
            component: () => import('@/views/notice/addNotice.vue'),
            meta: {
              title: '新增公告'
            }
          },
          {
            path: 'edit',
            name: 'editNotice',
            id: "5-1",
            component: () => import('@/views/notice/addNotice.vue'),
            meta: {
              title: '编辑公告'
            }
          }
        ]
      },
    ]
  },
  {
    path: '/',
    component: Layout,
    id: "7",
    redirect: '/user',
    meta: {
      title: '用户权限',
      icon: 'userrights.png',
    },
    children: [
      {
        path: 'rolemanagement',
        name: 'rolemanagement',
        id: "7-1",
        component: () => import('@/views/user/roleManagement/roleManagement.vue'),
        meta: {
          title: '角色管理'
        },
        children: [
          {
            path: 'addUser',
            name: 'addUser',
            id: "7-1",
            component: () => import('@/views/user/roleManagement/addUser.vue'),
            meta: {
              title: '添加用户'
            }
          },
          {
            path: 'getRoleType',
            name: 'getRoleType',
            id: "7-1",
            component: () => import("@/views/user/roleManagement/userRoleType.vue"),
            meta: {
              title: '角色授权'
            }
          }
        ]
      },
      {
        path:'/schooluser',
        name:'schooluser',
        id: "7-2",
        component:()=> import('@/views/user/schooluser/schoolUser.vue'),
        meta: {
          title: '院校用户',
        },
      },
      {
        path:'/stationuser',
        name:'stationuser',
        id: "7-3",
        component:()=> import('@/views/user/stationuser/stationUser.vue'),
        meta: {
          title: '函授站用户',
        },
      }
    ]
  },
  {
    path: '/sys',
    component: Layout,
    redirect: '/sys/systemSet',
    id: '6',
    meta: {
      title: '系统设置',
      icon: 'setting-icon.png',
    },
    children: [
      {
        path: 'systemSet',
        name: 'systemSet',
        id: '6-1',
        component: () => import('@/views/system/systemSet'),
        meta: {
          title: '系统设置'
        }
      },
      {
        path: "systemMessage",
        name: "systemMessage",
        id: '6-2',
        component: () => import("@/views/system/systemMessage"),
        meta: {
          title: "短信设置",
          // hiddenMenu: true
        }
      },
      {
        path: "customForm",
        name: "customForm",
        id: '6-3',
        component: () => import("@/views/system/customForm/index.vue"),
        meta: {
          title: "自定义学生信息",
          // hiddenMenu: true
        },
        // children: [
        //   {
        //     path: 'reviewForm',
        //     name: 'reviewForm',
        //     id: "6-3",
        //     component: () => import('@/views/system/customForm/reviewForm.vue'),
        //     meta: {
        //       title: '报名表预览'
        //     }
        //   }
        // ]
      },
      {
        path: 'TestIndex',
        name: 'TestIndex',
        id: '6',
        component: () => import('@/views/manage/manage'),
        hiddenMenu: true,
        meta: {
          title: '',
        }
      },
    ]
  },
  // 不需要layout
  {
    path: '/reviewForm',
    name: 'reviewForm',
    id: "6-3",
    component: () => import('@/views/system/customForm/reviewForm.vue'),
    hiddenMenu: true,
    meta: {
      title: '报名表预览'
    }
  }
]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes: constantRoutes
})

export default router
